import { uniqBy } from 'lodash';

const toUniqueTrims = (options) =>
  uniqBy(options, 'trimName').map((x) => x.trimName);

export default toUniqueTrims;
